import { Container, ContainerPadding, CTA } from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import React from 'react';

interface ModalFrameCloseCtaProps {
    aria : string,
    onClickHandler : () => void
}

const ModalFrameCloseCta = (props: ModalFrameCloseCtaProps) => {

    return (
        <Container
            padding={{ top: ContainerPadding.dynamic0040, left: ContainerPadding.dynamic0040, right: ContainerPadding.dynamic0040 }}
            horizontalAlign="flex-end">
            <CTA
                tag="button"
                emphasis="tertiary"
                size="small"
                onClick={() => props.onClickHandler() } ariaLabel={props.aria + ' button'}
                icon={<Close ariaLabel={props.aria + ' icon'} />} />
        </Container>
    );
}

export default ModalFrameCloseCta;
